/** Parse `auth` query param from a location `search` string (e.g. `?auth=jwt`). */
export function readAuthFromSearch(search) {
  if (search == null || search === '') return '';
  try {
    const q = new URLSearchParams(search).get('auth');
    return q?.trim() || '';
  } catch {
    return '';
  }
}


export function readPersonFromSearch(search) {
  if (search == null || search === '') return '';
  try {
    const person = new URLSearchParams(search).get('p');
    return person?.trim() || '';
  } catch {
    return '';
  }
}
